// The utm_source the visitor arrived with (e.g. /wa → whatsapp). Kept apart from Mixpanel so it works with tracking
// off, and in storage because the SPA drops the query on the first navigation. Not PII: a campaign tag.

const KEY = 'ca_entry_utm_source';

/** Call once at boot: remembers the latest tagged arrival */
export function captureEntryUtm(search: string = window.location.search): void {
  try {
    const source = new URLSearchParams(search).get('utm_source')?.trim();
    if (source) localStorage.setItem(KEY, source.slice(0, 64));
  } catch {
    // storage blocked: the referral question is simply asked
  }
}

/** A tagged link already tells us where the visitor came from, so "¿Cómo nos encontraste?" is skipped */
export function hasEntryUtmSource(): boolean {
  try {
    return !!localStorage.getItem(KEY);
  } catch {
    return false;
  }
}
